// React for Website

import React, { useState } from "react";
//outsource
import { Row, Col, Typography, Input, Button, Select } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const BranchAccessPOS = ({
  data,
  posData,
  staffs,
  handleAdd,
  handleRemove,
  disabled,
}) => {
  // -------------------------- VAR --------------------------
  const options = refineData(data);

  const pos = data?.filter((item) => {
    const valids = posData?.includes(item?.id);
    return valids;
  });
  // -------------------------- STATE --------------------------
  const [selected, setSelected] = useState("");
  // console.log("posData", posData);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col
          style={{ display: "flex", alignItems: "center" }}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Select
            style={{ width: "100%" }}
            showSearch
            options={options}
            placeholder="Select the staff"
            onSelect={(id) => setSelected(id)}
            disabled={disabled}
            optionFilterProp="label"
          />
          <span style={{ marginLeft: 8 }}>
            <Button
              onClick={() => handleAdd(selected)}
              type="primary"
              icon={<PlusOutlined />}
              disabled={disabled}
            />
          </span>
        </Col>
        <Col style={{ marginTop: 20 }} lg={24} md={24} sm={24} xs={24}>
          {renderListStaff()}
        </Col>
      </Row>
    );
  };

  const renderListStaff = () => {
    const staffs = refineData(pos);
    return (
      <Row>
        {staffs?.map((item) => {
          const key = item?.key;
          return (
            <Col
              key={key}
              style={{
                display: "flex",
                alignItems: "center",
                margin: "10px 0px",
              }}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Input value={item?.label} disabled />
              <span style={{ marginLeft: 8 }}>
                <Button
                  danger
                  type="default"
                  icon={<DeleteOutlined />}
                  onClick={() => handleRemove(key)}
                  disabled={disabled}
                />
              </span>
            </Col>
          );
        })}
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col lg={24} md={24} sm={24} xs={24}>
        <h1>Accessed Staff</h1>
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default BranchAccessPOS;

const refineData = (data) => {
  const newData = data?.map((item) => {
    const label = `${item.firstName} ${item.lastName} (${item?.phone})`;
    const value = item?.id;
    const key = item?.id;

    return {
      key,
      label,
      value,
    };
  });

  return newData;
};
